<div
  class="bg-light-cyan hover:bg-primary hover:bg-opacity-20 py-3 px-3 rounded-2xl flex cursor-pointer mb-[0.125rem] items-center gap-2"
  (click)="onOpenAppPreview()"
>
  <img class="w-5 h-5 inline relative" src="assets/images/animated-emojis/sparkles.webp" alt="sparkles emoji" />
  <span class="text-sm text-primary font-redHatTextSemibold">{{ 'sidebar.downloadAppTitle' | translate }}</span>
</div>
